import React, { useState } from "react";
import { motion } from "framer-motion";
import "../css/BookingCard.css";
import { useNavigate } from "react-router-dom"; 
import { useDispatch } from "react-redux";
import { setSelectedBooking } from "../redux/PackageSlice";

const BookingCard = ({
  name,
  avatar,
  type,
  datetime,
  amount,
  status,
  actions,
  booking,
  onClick,
  onAssign = [],
  serviceProvider,
  service_provider_name,
  service_provider_mobile_number
}) => {
  const [activeButton, setActiveButton] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate(); 
  const dispatch = useDispatch();

  const handleCardClick = () => {
    dispatch(setSelectedBooking(booking));
    navigate("/booking_detail");
  };

  if (!isVisible) return null;

  return (
    <motion.div
      className="booking-card"
      initial={{ opacity: 0, y: 30, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 30, scale: 0.95 }}
      transition={{ duration: 0.1, ease: "easeOut" }}
      whileHover={{ scale: 1.03, boxShadow: "0 8px 24px rgba(0,0,0,0.12)" }}
      onClick={handleCardClick}
    >
      {/* Header */}
      <div className="booking-card-header">
        <img src={avatar} alt={avatar} className="booking-avatar" />
        <div className="booking-details">
          <h3 className="booking-name">{name}</h3>
          <p className="booking-type">{type}</p>
          <p className="booking-datetime">{datetime}</p>
          <p className="booking-amount">
            Amount Paid: <span className="highlight">₹{amount}</span>
          </p>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="booking-card-actions">
        {actions.map((action, index) => (
          <motion.button
            key={index}
            className={`booking-btn ${activeButton === index ? "active" : ""} ${action.type}-btn`}
            whileTap={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
            onClick={(e) => {
              e.stopPropagation();
              setActiveButton(index);
              if (action.type === "reject") setIsVisible(false);
              if (action.onClick) action.onClick(e);
            }}
          >
            {action.label}
          </motion.button>
        ))}
      </div>

      {/* ✅ Assigned / Ongoing / Completed Booking Layout */}
      {["assigned", "ongoing", "completed"].includes(status) && (
        <div className="assigned-section">
          <p className="assigned-label">
            Assigned to <strong>{service_provider_name || "N/A"}</strong>
          </p>
        </div>
      )}

      {/* ✅ Ongoing / Completed Layout */}
      {["ongoing", "completed"].includes(status) && (
        <div className="booking-status-section">
          <p className="booking-status-line">
            {status === "completed"
              ? "This Booking has been Completed"
              : "This Booking has been Ongoing"}
          </p>
          <p className="booking-provider-line">
            Want to Talk With Service Provider?{" "}
            <span className="booking-provider-number">+91&nbsp;
              {service_provider_mobile_number ||
                booking?.service_provider_mobile_number ||
                booking?.service_provider?.mobile_number ||
                "N/A"}
            </span>
          </p>
        </div>
      )}
    </motion.div>
  );
};

export default BookingCard;
